import { type IValidatedResponse, postRequest } from '../../httpClient';
import type { IGetWatchStatusBatchV1Request } from './get-watch-status-batch-v1-request';
import {
  getWatchStatusBatchV1ResponseSchema,
  type IGetWatchStatusBatchV1Response,
} from './get-watch-status-batch-v1-response';

export async function getWatchStatusBatchV1Api({
  collectionIds,
}: IGetWatchStatusBatchV1Request): Promise<IValidatedResponse<IGetWatchStatusBatchV1Response>> {
  return postRequest<IGetWatchStatusBatchV1Response>({
    path: '/user-collections/watch-status/v1',
    body: { collectionIds },
    schema: getWatchStatusBatchV1ResponseSchema,
  });
}
